// extracted by mini-css-extract-plugin
module.exports = {"draftUploadHeading":"DraftUpdate_draftUploadHeading__3WxYw","mainHeadline":"DraftUpdate_mainHeadline__2Sfn4"};